/*
 * File: index.tsx
 * Desc: 滚动到顶部组件
 * File Created: 2019-09-25 16:48:53
 * Author: chenghao at <hao.cheng@karakal.com.cn>
 * ------
 * Copyright 2019 - present, karakal
 */
import React, { useEffect } from 'react';
import { usePrevious } from 'react-use';

type ScrollUpProps = {
    location: any;
    children: React.ReactElement;
};

/** 滚动到顶部 */
const ScrollUp = (props: ScrollUpProps) => {
    const prevLocation = usePrevious(props.location);
    useEffect(() => {
        if (prevLocation && prevLocation.pathname !== props.location.pathname) {
            window.scrollTo(0, 0);
        }
    }, [props.location, prevLocation]);
    return props.children;
};

export default ScrollUp;
